import { formatCurrencyInt } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

const convertFloor = (numberLike: string): number => parseInt(numberLike, 10)

export const conversion = ({ floorAmount, saleAmount }: SearchVehicle): string => {
    const floorConversion = floorAmount ? convertFloor(floorAmount) : ''
    const saleConversion = saleAmount ? convertFloor(saleAmount) : ''

    if (floorConversion) {
        return `${formatCurrencyInt(floorConversion)} (${Math.round(
            (saleConversion ? saleConversion / floorConversion : 0) * 100,
        )}%)`
    }
    return '--'
}
